import React from "react";
import { Route, Switch } from "react-router-dom";
import Add from "./Add";
import List from "./List";
import Summary from "./Summary";
import Task from "./Task";
import Material from "./Material";
import Recourses from "./Recourses";
import Outcome from "./Outcome";

function Jobs({ match }) {
  const { path } = match;
  return (
    <Switch>
      <Route exact path={path} component={List} />
      <Route path={`${path}/add`} component={Add} />
      <Route path={`${path}/:id/summary`} component={Summary} />
      <Route path={`${path}/:id/tasks`} component={Task} />
      <Route path={`${path}/:id/materials`} component={Material} />
      <Route path={`${path}/:id/recourses`} component={Recourses} />
      <Route path={`${path}/:id/outcomes`} component={Outcome} />
    </Switch>
  );
}

export { Jobs };
